import { inject, Injectable } from '@angular/core';
import StackTrace from 'stacktrace-js';

import { ERROR_LOGGERS } from './error-loggers.token';
import { HttpError } from './http-error.model';
import { LogLevel } from './log-level.model';

const DEFAULT_EXCEPTION = 'No stack trace available';
const FRAMES_LIMIT = 2;

@Injectable({ providedIn: 'root' })
export class ErrorLoggerService {
  readonly #loggers = inject(ERROR_LOGGERS);

  handleHttpError(error: HttpError): void {
    this.#loggers
      .filter((logger) => logger.available())
      .forEach((logger) => {
        logger.logHttpError(error).catch((e) => console.error(e));
      });
  }

  async handleJsError(error: Error, level: LogLevel = 'error'): Promise<void> {
    let exception = DEFAULT_EXCEPTION;

    try {
      const frames = await StackTrace.fromError(error);

      if (frames.length > 0) {
        exception = [
          frames[0].getFileName(),
          frames[0].getLineNumber(),
          frames[0].getColumnNumber(),
        ].join(':');
      }
    } catch (e) {
      exception = error.stack
        ?.split('\n')
        ?.slice(0, FRAMES_LIMIT)
        ?.map((v) => v.trim())
        ?.join(':') ?? DEFAULT_EXCEPTION;
    }

    this.#loggers
      .filter((logger) => logger.available())
      .forEach((logger) => {
        logger.logJsError(error, exception, level).catch((e) => console.error(e));
      });
  }
}
